var map = {
	"../companies/details-compaines/details-compaines.module.ngfactory": [
		"beGC",
		1,
		2,
		12,
		0,
		61
	],
	"../customer/customer-details/customer-details.module.ngfactory": [
		"1PW7",
		1,
		2,
		3,
		14,
		0,
		62
	],
	"../vendors/vendor-details/vendor-details.module.ngfactory": [
		"ElfL",
		1,
		2,
		7,
		11,
		0,
		70
	],
	"./detail-adminuser/detail-adminuser-routing.module.ngfactory": [
		"oH62",
		1,
		2,
		0,
		63
	],
	"./job-details/job-details.module.ngfactory": [
		"h/qX",
		1,
		2,
		7,
		8,
		9,
		15,
		0,
		65
	],
	"app/views/pages/accounts-reports/reports.module.ngfactory": [
		"l6st",
		1,
		2,
		3,
		4,
		0,
		17
	],
	"app/views/pages/action-required/action-required.module.ngfactory": [
		"Fvsq",
		1,
		2,
		3,
		5,
		4,
		7,
		13,
		0,
		18
	],
	"app/views/pages/admin-roles/admin-roles.module.ngfactory": [
		"2kR9",
		3,
		5,
		4,
		6,
		0,
		19
	],
	"app/views/pages/admin-users/admin-users.module.ngfactory": [
		"IJGC",
		1,
		2,
		3,
		4,
		0,
		20
	],
	"app/views/pages/cancel-resons/cancel-resons.module.ngfactory": [
		"Lf4R",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		21
	],
	"app/views/pages/cancel-resons/customer-cancel-reasons/customer-cancel-reasons.module.ngfactory": [
		"GHq3",
		1,
		2,
		0,
		22
	],
	"app/views/pages/cancelation/cancelation.module.ngfactory": [
		"Pj7U",
		3,
		5,
		4,
		0,
		23
	],
	"app/views/pages/categories/catagories.module.ngfactory": [
		"MwYc",
		1,
		2,
		3,
		5,
		4,
		0,
		24
	],
	"app/views/pages/cities/cities.module.ngfactory": [
		"6sH5",
		1,
		2,
		3,
		5,
		4,
		6,
		9,
		0,
		25
	],
	"app/views/pages/companies/companies.modules.ngfactory": [
		"/JLK",
		1,
		2,
		3,
		5,
		4,
		6,
		9,
		0,
		26
	],
	"app/views/pages/coupons/coupon.module.ngfactory": [
		"PCCH",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		27
	],
	"app/views/pages/customer-class/customer-class.module.ngfactory": [
		"kjft",
		1,
		2,
		3,
		5,
		4,
		0,
		28
	],
	"app/views/pages/customer-loyality-history/customer-loyality.module.ngfactory": [
		"LA4s",
		1,
		2,
		3,
		5,
		4,
		0,
		30
	],
	"app/views/pages/customer-onlinetransction/customer-transction.module.ngfactory": [
		"AZye",
		1,
		2,
		3,
		5,
		4,
		0,
		31
	],
	"app/views/pages/customer-wallet/customer-wallet.module.ngfactory": [
		"1emQ",
		1,
		2,
		3,
		5,
		4,
		0,
		32
	],
	"app/views/pages/customer/customer.module.ngfactory": [
		"WiMf",
		1,
		2,
		5,
		8,
		14,
		0,
		29
	],
	"app/views/pages/dashboard/dashboard.module.ngfactory": [
		"kIFp",
		0,
		33
	],
	"app/views/pages/default-time-slots/default-time-slots.module.ngfactory": [
		"YJqL",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		34
	],
	"app/views/pages/jobs/jobs.module.ngfactory": [
		"eqP1",
		1,
		2,
		5,
		6,
		7,
		8,
		9,
		15,
		0,
		35
	],
	"app/views/pages/localisation/localisation.module.ngfactory": [
		"v/zl",
		3,
		5,
		4,
		6,
		0,
		36
	],
	"app/views/pages/loyality-settings/loyalitysetting.module.ngfactory": [
		"30J/",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		37
	],
	"app/views/pages/nationality/nationality.module.ngfactory": [
		"Xobw",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		38
	],
	"app/views/pages/notifications/notifications.module.ngfactory": [
		"UYP4",
		1,
		2,
		0,
		39
	],
	"app/views/pages/operation-performance/operation-performance.module.ngfactory": [
		"Csdv",
		1,
		2,
		3,
		5,
		4,
		0,
		40
	],
	"app/views/pages/packages/packages.module.ngfactory": [
		"TLGl",
		1,
		2,
		3,
		5,
		4,
		6,
		13,
		0,
		41
	],
	"app/views/pages/review-data/review-data.module.ngfactory": [
		"9xNH",
		3,
		5,
		4,
		6,
		0,
		42
	],
	"app/views/pages/role-permissions/role-permission.module.ngfactory": [
		"5yJx",
		3,
		5,
		4,
		6,
		0,
		43
	],
	"app/views/pages/settings/setting.module.ngfactory": [
		"zUr5",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		44
	],
	"app/views/pages/special-coupon/specialcoupon.module.ngfactory": [
		"esSr",
		1,
		2,
		3,
		5,
		4,
		0,
		45
	],
	"app/views/pages/special-hours/special-hours.module.ngfactory": [
		"ICaM",
		1,
		2,
		3,
		5,
		4,
		0,
		46
	],
	"app/views/pages/templates/template.module.ngfactory": [
		"ueMK",
		1,
		2,
		3,
		5,
		4,
		6,
		0,
		47
	],
	"app/views/pages/transfer-request/transfer-request.module.ngfactory": [
		"SNSa",
		1,
		2,
		3,
		5,
		4,
		0,
		48
	],
	"app/views/pages/users-reports/reports.module.ngfactory": [
		"N4TO",
		1,
		2,
		3,
		4,
		0,
		49
	],
	"app/views/pages/vendor-class/vendor-class.module.ngfactory": [
		"7I/f",
		1,
		2,
		3,
		5,
		4,
		0,
		50
	],
	"app/views/pages/vendor-loyality-setting/vendor-loyality-setting.module.ngfactory": [
		"Dxo0",
		1,
		2,
		3,
		5,
		4,
		0,
		51
	],
	"app/views/pages/vendor-online-transaction/vendoronlinetransction.module.ngfactory": [
		"FG9N",
		1,
		2,
		3,
		5,
		4,
		0,
		52
	],
	"app/views/pages/vendor-role/vendor-role.module.ngfactory": [
		"9geM",
		1,
		2,
		3,
		5,
		4,
		0,
		53
	],
	"app/views/pages/vendor-wallet/vendor-wallet.module.ngfactory": [
		"xL5p",
		1,
		2,
		3,
		5,
		4,
		0,
		54
	],
	"app/views/pages/vendors/vendors.module.ngfactory": [
		"g+h1",
		1,
		2,
		5,
		8,
		0,
		55
	],
	"app/views/pages/zones/zones.module.ngfactory": [
		"sr65",
		0,
		56
	],
	"app/views/themes/default/content/builder/builder.module.ngfactory": [
		"Wbbl",
		8,
		0,
		57
	],
	"app/views/themes/default/theme.module.ngfactory": [
		"ckTZ",
		1,
		3,
		5,
		4,
		6,
		7,
		12,
		11,
		16,
		0,
		58
	],
	"app/views/themes/demo2/content/builder/builder.module.ngfactory": [
		"FtuR",
		8,
		0,
		59
	],
	"app/views/themes/demo2/theme.module.ngfactory": [
		"z/r4",
		1,
		3,
		5,
		4,
		6,
		7,
		12,
		11,
		16,
		0,
		60
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;